export default "__VITE_ASSET__DUsh3XkA__"